import React from "react";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { aggregateUserPortfoGroup } from "src/Requests/portfolioGroups";
import type {
  IAggregateUserSearchParams,
  IAggregateUserTableReport,
} from "src/Interfaces/portfolioGroups";

interface IProps {
  refreshFlag?: boolean;
  activePortfoGroupId?: number | null;
  onPortfoGroupClick?: (portfoGroupId: number | null) => void;
}

const AggregateTable: React.FC<IProps> = ({
  refreshFlag,
  activePortfoGroupId,
  onPortfoGroupClick,
}) => {
  const searchParams = React.useMemo(
    () => ({}) as IAggregateUserSearchParams,
    [],
  );

  return (
    <TableTemplate<IAggregateUserSearchParams, IAggregateUserTableReport>
      getDataTable={aggregateUserPortfoGroup}
      searchParameters={searchParams}
      TableUI={({ reports, onAction, sortingType, setSortingType }) => {
        const activeRow = reports.report.find(
          (row) => row.portfoGroupId === activePortfoGroupId,
        );

        return (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0 max-h-[280px]"
            refreshFlag={refreshFlag}
            activeRowId={activeRow?.id}
            onTableRowClick={(row) =>
              onPortfoGroupClick?.(row.portfoGroupId ?? null)
            }
          />
        );
      }}
      tableWrapperClassname="!mx-0 !w-[400px]"
      refreshTableTime={30000}
      pagesize={50}
    />
  );
};

export default AggregateTable;
